import axios from 'axios';
import { API_BASE_URL } from '@config';

//GET_ACCOUNTS
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const setAccountStore = accounts => {
	return {
		type: GET_ACCOUNTS,
		payload: accounts
	};
};

export const getAccount = param => dispatch => {
	const startDate = new Date(param.startDate).valueOf();
	const endDate = new Date(param.endDate).valueOf();

	const request = axios.get(`${API_BASE_URL}/api/account/${startDate}/${endDate}`);
	return request
		.then(res => {
			dispatch(setAccountStore(res.data));
		})
		.catch(() => {
			console.error('error...');
		});
};

//GET_ACCOUNTS_CLUTERS
export const GET_ACCOUNTS_CLUSTERS = 'GET_ACCOUNTS_CLUSTERS';
export const setAccountClustersStore = accountsClusters => {
	return {
		type: GET_ACCOUNTS_CLUSTERS,
		payload: accountsClusters
	};
};

//get Accoun Clusters
export const getAccountClusters = param => dispatch => {
	const startDate = new Date(param.startDate).valueOf();
	const endDate = new Date(param.endDate).valueOf();

	const request = axios.get(`${API_BASE_URL}/api/usages/${startDate}/${endDate}`);
	return request
		.then(res => {
			dispatch(setAccountClustersStore(res.data));
		})
		.catch(() => {
			console.error('error...');
		});
};

//GET DETAILS ACOUNTS Cluster
export const GET_DETAILS_CLUSTERS = 'GET_DETAILS_CLUSTERS';
export const setAccountClustersDetailsStore = account => {
	return {
		type: GET_DETAILS_CLUSTERS,
		payload: account
	};
};

//get Accoun Clusters
export const getAccountClustersDetails = param => dispatch => {
	const startDate = new Date(param.startDate).valueOf();
	const endDate = new Date(param.endDate).valueOf();

	const request = axios.get(`${API_BASE_URL}/api/usages/details/${param.clusterId}/${startDate}/${endDate}`);
	return request
		.then(res => {
			dispatch(setAccountClustersDetailsStore(res.data));
		})
		.catch((error) => {
			console.error(error);
		});
};

//GET DETAILS ACOUNTS
export const GET_DETAILS_ACCOUNTS = 'GET_DETAILS_ACCOUNTS';
export const setAccountDetailsStore = account => {
	return {
		type: GET_DETAILS_ACCOUNTS,
		payload: account
	};
};

export const getAccountDetails = param => dispatch => {
	const startDate = new Date(param.startDate).valueOf();
	const endDate = new Date(param.endDate).valueOf();

	const request = axios.get(`${API_BASE_URL}/api/account/details/${param.userAccount}/${startDate}/${endDate}`);
	return request
		.then(res => {
			dispatch(setAccountDetailsStore(res.data));
		})
		.catch((error) => {
			console.error(error);
		});
};

//SET START_TIME
export const START_TIME = 'START_TIME';
export const setStartTime = startTime => {
	return {
		type: START_TIME,
		payload: startTime
	};
};

//SET END_TIME
export const END_TIME = 'END_TIME';
export const setEndTime = EndTime => {
	return {
		type: END_TIME,
		payload: EndTime
	};
};
